type TEnvironment = 'development' | 'staging' | 'production';

export const shouldInit = (environments: TEnvironment[] = ['development', 'staging', 'production']) => {
  const environment = import.meta.env.REACT_APP_DOMAIN as TEnvironment;

  return environments.includes(environment);
};
